import React, { useEffect } from 'react'
import { Navigate } from 'react-router-dom';
import { t } from 'i18next'
import { SidebarLeft } from '../../../components/Page/logix2020/SidebarLeft'
import SidebarNavigation from '../../../components/Page/logix2020/SidebarNavigation'
import { FlexWrapper } from '../../../components/Page/logix2020/FlexWrapper'
import { Subheader } from '../../../components/Page/logix2020/Subheader'
import SubheaderTitle from '../../../components/Page/logix2020/SubheaderTitle'
import { ContentArea } from '../../../components/Page/logix2020/ContentArea'
import BigFooter from '../../../components/Footer/BigFooter'
import AssetTypeGeneralForm from '../../../components/Configuration/AssetTypes/AssetTypeGeneralForm'
import { useAssetTypesState } from '../../../stores/Configuration/AssetTypesProvider'

const navigationLeft = () => {

  return [
    {
      key: '#base',
      to: '#base',
      name: t('contingentTemplates:base'),
      disabled: false
    },
    {
      key: '#activities',
      to: '#activities',
      name: t('contingentTemplates:activities'),
      disabled: true
    }
  ]
}

const CreateAssetTypePage = () => {
  const { redirectId, resetAssetTypesPage } = useAssetTypesState()

  useEffect(() => {
    resetAssetTypesPage()
  }, [resetAssetTypesPage])

  // redirect to edit page after new phase was created
  if (redirectId) {
    return <Navigate
      to={`/assetTypesAdministration/edit/${redirectId}`}
      replace
    />
  }

  return (
    <div>
      <Subheader className="subHeader-v1">
        <SubheaderTitle
          withBackButton
          smallTitle={t('assetTypes:addAssetType')}
          goBackLabel={t('assetTypes:assetTypesOverview')}
          defaultBackTo="/assetTypesAdministration"
        />
      </Subheader>
      <FlexWrapper>
        <SidebarLeft>
          <SidebarNavigation options={navigationLeft()} active='base' />
        </SidebarLeft>
        <ContentArea>
          <AssetTypeGeneralForm />
        </ContentArea>
      </FlexWrapper>
      <BigFooter />
    </div>
  )
}

export default CreateAssetTypePage